import React, { useContext, useState } from "react";
import { changeNotificationsDate } from "../../apiClient/operations/paymentCollectionManagerOperations";
import { ModalNotification } from "../modals/ModalNotification";
import PrimaryButton from "../../tailwindUI/PrimaryButton";
import { FormInput } from "../FormInput";
import { useForm } from "react-hook-form";
import SecondaryButton from "../../tailwindUI/SecondaryButton";
import SecondaryLoader from "../../hooks/SecondaryLoader";
import { AlertContext } from "../../context/AlertContext";

function getDaysInCurrentMonth() {
  const year = new Date().getFullYear();
  const month = new Date().getMonth() + 1; // January gives 0

  return new Date(year, month, 0).getDate();
}

export function UpdateNotificationsDate() {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { setAlert } = useContext(AlertContext);
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: {
      day: "",
    },
    mode: "onChange",
  });

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      const response = await changeNotificationsDate({
        day: data.day,
      });
      setAlert({
        active: true,
        type: "success",
        message: response.message || "Fecha actualizada",
      });
      setShowModal(false);
      reset();
    } catch (error) {
      console.log({ error });
      setAlert({
        active: true,
        type: "error",
        message: "Error al procesar tu solicitud",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onCancel = () => {
    setShowModal(false);
    reset();
  };

  return (
    <>
      {isLoading && <SecondaryLoader />}
      <div className="w-full lg:w-fit">
        <PrimaryButton isFullWidth={true} onClick={() => setShowModal(true)}>
          <span className="text-[15px] md:text-sm py-0.5 md:py-1 font-medium">
            Cambiar fecha de envío
          </span>
        </PrimaryButton>
      </div>
      <ModalNotification
        showModal={showModal}
        setShowModal={setShowModal}
        title="Cambiar fecha de envío"
        classNameActions="flex-row justify-end w-full max-w-[200px] ml-auto"
        content={
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormInput
              key="day"
              name="day"
              label="Día del mes"
              placeholder="15"
              variant="input"
              type="number"
              register={register}
              errors={errors}
              rules={{
                required: "*El día es obligatorio",
                valueAsNumber: true,
                validate: (v) => {
                  const maxDay = getDaysInCurrentMonth();
                  if (v <= 0) {
                    return "* Debe ser mayor a 0";
                  } else if (v > maxDay) {
                    return `* Debe ser menor a ${maxDay}`;
                  }
                  return true;
                },
              }}
            />

            <div className="flex justify-end gap-4 mt-6">
              <SecondaryButton
                type="button"
                disabled={isLoading}
                onClick={onCancel}
              >
                Cancelar
              </SecondaryButton>
              <PrimaryButton type="submit" disabled={isLoading}>
                Confirmar
              </PrimaryButton>
            </div>
          </form>
        }
      />
    </>
  );
}
